import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import React from 'react';

const styles = require('./Spinner-styles.module.scss');

/* eslint-disable max-len */
export default function Spinner({ className, ...props }) {
  return (
    <svg
      viewBox="0 0 34 34"
      className={classNames(className, styles.container)}
      {...props}
    >
      <g fill="none">
        <g transform="translate(-3, 0)">
          <g transform="translate(2, 2)">
            <g className={styles.outerCircle}>
              <path d="M30,15 C30,6.71572875 23.2842712,0 15,0 C6.71572875,0 2.55795385e-13,6.71572875 2.55795385e-13,15" />
            </g>
            <g className={styles.innerCircle}>
              <path d="M12,0 C5.372583,0 -1.77635684e-15,5.372583 -1.77635684e-15,12" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
